import { getAdder, getUnitStart, format } from "../time";
import { addMonths, areIntervalsOverlapping, endOfDay, isFuture, isSameDay, isToday, startOfDay, } from "date-fns";
import { sortEvents } from "../events";
const addDays = getAdder("day");
class AgendaView {
    constructor() {
        this.getBounds = (date) => {
            const start = getUnitStart("day", date);
            const end = addMonths(start, 2);
            return [start, end];
        };
        this.getNext = (date) => {
            const start = addDays(date, 1);
            return start;
        };
        this.getPrev = (date) => {
            const start = addDays(date, -1);
            return start;
        };
    }
    getTitle(date, config) {
        const { dateTitle } = this._config;
        return dateTitle
            ? dateTitle(date, this.getBounds(date))
            : format(date, "d LLL y", { locale: config.locale });
    }
    addEvent(event) {
        this._events.push(event);
    }
    getEventById(id) {
        return this._events.find(e => e.id === id);
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    removeEvent() { }
    calculateMinutesLinePosition() {
        const margin = 4; // hard coded in styles
        const { eventHeight } = this._config;
        const today = this._days.find(({ date }) => isToday(date));
        if (!today)
            return;
        const { events } = today;
        const index = events.findIndex(({ start_date }) => isFuture(start_date));
        const top = index < 0
            ? (eventHeight + margin) * events.length
            : (eventHeight + margin) * index || margin;
        return `${top}px`;
    }
    getViewModel(_activeDate, bounds, config, displayedEvents, calendars) {
        const days = [];
        let start = startOfDay(bounds[0]);
        const end = endOfDay(bounds[1]);
        this._config = config;
        const sortedEvents = sortEvents(displayedEvents);
        this._events = displayedEvents;
        while (!isSameDay(start, end)) {
            const events = sortedEvents.filter(event => areIntervalsOverlapping({ start, end: endOfDay(start) }, { start: event.start_date, end: event.end_date }));
            if (events.length) {
                days.push({
                    date: start,
                    events,
                });
            }
            start = addDays(start, 1);
        }
        this._days = days;
        return {
            title: this.getTitle.bind(this),
            addEvent: this.addEvent.bind(this),
            getEventById: this.getEventById.bind(this),
            days,
            calendars,
            activeDate: _activeDate.toString(),
            removeEvent: this.removeEvent.bind(this),
            calculateMinutesLinePosition: this.calculateMinutesLinePosition.bind(this),
        };
    }
}
export default AgendaView;
//# sourceMappingURL=agenda.js.map